import { IFrame } from '@civilgrid/ui/components';

const RegisterContact = () => {
  return (
    <div className="rounded-lg bg-white p-6 shadow-lg">
      <IFrame
        src="https://calendly.com/zack-civilgrid/intro_meeting"
        title="Schedule an intro meeting with CivilGrid"
        width={400}
        height={700}
      />
    </div>
  );
};

export default RegisterContact;
